import React from 'react';
import Icons from 'components/atoms/Icons';

type TagProps = {
	displayName?: string;
	filterName: string;
	filterCategory: string;
	removeFilter: Function;
	updateLonLatFilter?: Function
}

type ExtraTags = {
	acceptingnewpatients: string;
	onlinescheduling: string;
};

const Tag = (props: TagProps) => {
	const extraTags: ExtraTags = {
		acceptingnewpatients: 'Accepting New Patients',
		onlinescheduling: 'Online Scheduling Available',
	};
	const tagDescription = Object.keys(extraTags).includes(props.filterCategory)
		? extraTags[props.filterCategory as keyof ExtraTags]
		: props.displayName
		? props.displayName
		: props.filterName;

	return (
		<div className="tag">
			<div
				className="tag-description"
				onClick={() => {
					props.removeFilter(props.filterCategory, props.filterName);
					props.updateLonLatFilter && props.updateLonLatFilter('lonlat', []);
				}}
			>
				<span className="filter-value">{tagDescription}</span>
			</div>
			<button
				className="tag-remove-btn"
				onClick={() => {
					props.removeFilter(props.filterCategory, props.filterName);
					props.updateLonLatFilter && props.updateLonLatFilter('lonlat', []);
				}}
				aria-label={
					'Remove ' + (props.displayName ? props.displayName : tagDescription) + ' filter.'
				}
			>
				<Icons id="close" className="icon icon-close" aria-role="img" aria-hidden="true" />
			</button>
		</div>
	);
};

export default Tag;